import React from 'react';

interface IconProps {
  className?: string;
  fontSize?: 'small' | 'medium' | 'large' | 'inherit';
  color?: string;
  sx?: React.CSSProperties & { color?: string };
}

const createIcon = (faClass: string) => {
  const IconComponent: React.FC<IconProps> = ({ className = '', fontSize = 'medium', color, sx }) => {
    const sizeClasses = {
      small: 'text-sm',
      medium: 'text-base',
      large: 'text-lg',
      inherit: '',
    };

    const iconColor = sx?.color || color;

    return (
      <i
        className={`${faClass} ${sizeClasses[fontSize]} ${className}`}
        style={{ color: iconColor, ...sx }}
      />
    );
  };
  return IconComponent;
};

export const Add = createIcon('fa-solid fa-plus');
export const Delete = createIcon('fa-solid fa-trash');
export const Edit = createIcon('fa-solid fa-pen');
export const Search = createIcon('fa-solid fa-magnifying-glass');
export const Visibility = createIcon('fa-solid fa-eye');
export const VisibilityOff = createIcon('fa-solid fa-eye-slash');
export const Pageview = createIcon('fa-solid fa-eye');
export const ExpandMore = createIcon('fa-solid fa-chevron-down');
export const ExpandLess = createIcon('fa-solid fa-chevron-up');
export const ArrowBackIosNewRounded = createIcon('fa-solid fa-arrow-left');

